import VueRouter from "vue-router"
import OrganizationLibrary from '@/views/OrganizationLibrary'
import CaseDetail from '@/views/CaseDetail'
import CaseSettings from '@/views/CaseSettings'
import NodeDetail from '@/views/NodeDetail'
import LearnerDetail from '@/views/LearnerDetail'
import MemberList from '@/views/MemberList'
import LearnerDefault from '@/views/LearnerDefault'
import LearnerCaseSession from '@/views/LearnerCaseSession'
import LearnerHistory from '@/views/LearnerHistory'
import PreviewCaseSession from '@/views/PreviewCaseSession'
import view404 from '@/views/NotFound'
import ReportView from '@/views/ReportView'
import ShareLinks from '@/views/ShareLinks'
import CommunityLibrary from '@/views/CommunityLibrary'
import CaseNodeMap from '@/views/CaseNodeMap'
import LMSIntegrationSettings from '@/views/LMSIntegrationSettings'
import ImageHotspotsEditor from '@/views/ImageHotspotsEditor'
import CustomFormEditor from '@/views/CustomFormEditor'
import CaseTimers from '@/views/CaseTimers'
import CommunityPublishersAdmin from '@/views/CommunityPublishersAdmin'
import CommunityPublisherDetail from '@/views/CommunityPublisherDetail'
import CommunityCaseDetail from '@/views/CommunityCaseDetail'
import CommunityCaseSessions from '@/views/CommunityCaseSessions'
import ChatAgents from '@/views/ChatAgents'
import ChatAgentDetail from "@/views/ChatAgentDetail"
import LinkReports from "@/views/LinkReports"
import CaseSessionSetup from "@/views/CaseSessionSetup"
import OrganizationDetails from "@/views/OrganizationDetails"
import PublishPages from "@/views/PublishPages"
import PublishPageEditor from "@/views/PublishPageEditor"
import PublishPageViewer from "@/views/PublishPageViewer"
import PublishPageViewerSetup from "@/views/PublishPageViewerSetup"
import LmsContentSelector from "@/views/LmsContentSelector"


const router = new VueRouter({
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		if (to.name == "CommunityLibrary") return {}
		return {
			x: 0,
			y: 0
		}
	},
	routes: [
		{
			path: '/author',
			redirect: '/library/'
		},
		{
			path: '/users/',
			name: 'MemberList',
			component: MemberList,
			meta: {
				title: 'Users'
			}
		},
		{
			path: '/users/:id/',
			name: 'LearnerDetail',
			component: LearnerDetail,
			meta: {
				title: 'User'
			}
		},
		{
			path: '/pages/',
			name: 'Pages',
			component: PublishPages,
			meta: {
				title: 'Pages'
			}
		},
		{
			path: '/pages/:id/',
			name: 'PageEditor',
			component: PublishPageEditor,
			meta: {
				title: 'Edit Page'
			}
		},
		{
			path: '/pages/:pageId/reports',
			name: 'PageReports',
			component: ReportView,
			meta: {
				title: 'Learner Reports',
			}
		},
		{
			path: '/pages/:id/share/:shareLinkID/setup',
			name: 'PageViewerSetup',
			component: PublishPageViewerSetup,
			meta: {
				title: 'Information Required',
				hideTopNav: true,
			}
		},
		{
			path: '/pages/:id/share/:shareLinkID/view',
			name: 'PageViewerShare',
			component: PublishPageViewer,
			meta: {
				title: 'View Page',
				hideLoginPrompts: true,
				allowCustomLogo: true,
			}
		},
		{
			path: '/pages/:id/view',
			name: 'PageViewer',
			component: PublishPageViewer,
			meta: {
				title: 'View Page',
				hideLoginPrompts: true,
				allowCustomLogo: true,
			}
		},
		{
			path: '/pages/:pageID/share/:shareLinkID/sessions/:sessionID',
			name: 'PageViewerShareSession',
			component: LearnerCaseSession,
			meta: {
				title: 'View Page',
				caseSessionIsActive: true,
			}
		},
		{
			path: '/library/',
			name: 'OrganizationLibrary',
			component: OrganizationLibrary,
			meta: {
				title: 'Library'
			}
		},
		{
			path: '/library/:id/',
			name: 'CaseDetail',
			component: CaseDetail,
			meta: {
				title: 'Edit'
			},
			children: [
				{
					path: 'settings/',
					name: 'CaseSettings',
					component: CaseSettings,
					meta: {
						title: 'Settings',
						parent: 'CaseDetail'
					}
				},
				{
					path: 'reviewers/',
					redirect: 'share'
				},
				{
					path: 'share/',
					name: 'ShareLinks',
					component: ShareLinks,
					meta: {
						title: 'Share Links',
						parent: 'CaseDetail'
					},
				},
				{
					path: 'share/:linkId/',
					name: 'LinkReports',
					component: LinkReports,
					meta: {
						title: 'Learner Reports',
						parent: 'CaseDetail'
					},
				},
				{
					path: 'nodes/:nodeID/',
					name: 'NodeDetail',
					component: NodeDetail,
					meta: {
						title: 'Screen Editor',
						parent: 'CaseDetail'
					}
				},
				{
					path: 'map',
					name: 'CaseNodeMap',
					component: CaseNodeMap,
					meta: {
						title: 'Map',
						parent: 'CaseDetail'
					}
				},
				{
					path: 'timers',
					name: 'CaseTimers',
					component: CaseTimers,
					meta: {
						title: 'Timers',
						parent: 'CaseDetail'
					}
				},
			]
		},
		{
			path: '/library/:caseID/nodes/:nodeID/panel/:panelID/hotspots/',
			name: 'ImageHotspotsEditor',
			component: ImageHotspotsEditor,
			meta: {
				title: 'Edit Hotspots'
			}
		},
		{
			path: '/library/:caseID/nodes/:nodeID/panel/:panelID/custom-form/',
			name: 'CustomFormEditor',
			component: CustomFormEditor,
			meta: {
				title: 'Edit Custom Form'
			}
		},
		{
			path: '/library/:caseID/preview/:sessionID/',
			name: 'PreviewCaseSession',
			component: PreviewCaseSession,
			meta: {
				title: 'Viewing:',
				caseSessionIsActive: true,
			}
		},
		{
			path: '/reports/',
			name: 'ReportView',
			component: ReportView,
			meta: {
				title: 'Report View'
			}
		},
		// Student Views
		{
			path: '/cases/',
			redirect: '/learner'
		},
		{
			path: '/learner',
			alias: '/scenarios/',
			name: 'LearnerDefault',
			component: LearnerDefault,
			meta: {
				title: 'Library'
			}
		},
		{
			path: '/sessions/:sessionID/',
			name: 'LearnerCaseSession',
			component: LearnerCaseSession,
			meta: {
				title: 'Viewing:',
				caseSessionIsActive: true,
			}
		},
		{
			path: '/history/',
			name: 'LearnerHistory',
			component: LearnerHistory,
			meta: {
				title: 'Learner History'
			}
		},
		// Share Link Session
		{
			path: '/share/:shareLinkID/sessions/:sessionID/',
			alias: '/review/:shareLinkID/sessions/:sessionID/',
			name: 'ShareLinkCaseSession',
			component: LearnerCaseSession,
			meta: {
				title: 'Session',
				caseSessionIsActive: true,
			}
		},
		{
			path: '/share/:shareLinkID/sessions/:sessionID/setup',
			alias: '/review/:shareLinkID/sessions/:sessionID/setup',
			name: 'CaseSessionSetup',
			component: CaseSessionSetup,
			meta: {
				title: 'Information Required',
				caseSessionIsActive: true,
			}
		},
		// Community
		{
			path: '/community/browse',
			name: 'CommunityLibrary',
			component: CommunityLibrary,
			meta: {
				title: 'Community Library'
			}
		},
		{
			path: '/community',
			redirect: { name: 'CommunityLibrary' }
		},
		{
			path: '/community/browse/:id',
			name: 'CommunityCaseDetail',
			component: CommunityCaseDetail,
			meta: {
				title: 'Community Library'
			}
		},
		{
			path: '/community/sessions',
			name: 'CommunityCaseSessions',
			component: CommunityCaseSessions,
			meta: {
				title: 'In Progress'
			}
		},
		{
			path: '/community/publishers',
			name: 'CommunityPublishersAdmin',
			component: CommunityPublishersAdmin,
			meta: {
				title: 'Publishers'
			}
		},
		{
			path: '/community/publishers/:id',
			name: 'CommunityPublisherDetail',
			component: CommunityPublisherDetail,
			meta: {
				title: 'Publisher Profile'
			}
		},
		{
			path: '/community/play/:caseID/sessions/:sessionID',
			name: 'CommunityCaseSession',
			component: LearnerCaseSession,
			meta: {
				title: 'Learner Session',
				caseSessionIsActive: true,
			}
		},
		{
			path: '/organization/integrations',
			name: 'LMSIntegrationSettings',
			component: LMSIntegrationSettings,
			meta: {
				title: 'LMS Integrations'
			}
		},
		{
			path: '/manage/chat-agents',
			name: 'ChatAgents',
			component: ChatAgents,
			meta: {
				title: 'Chat Agents'
			}
		},
		{
			path: '/manage/chat-agents/:id/',
			name: 'ChatAgentDetail',
			component: ChatAgentDetail,
			meta: {
				title: 'Edit Chat Agent'
			}
		},
		{
			path: "/organization/settings",
			name: "OrganizationDetails",
			component: OrganizationDetails,
			meta: {
				title: "Organization Settings"
			},
		},
		{
			path: "/lms/launch/:id/content-selection",
			name: "LmsContentSelector",
			component: LmsContentSelector,
			meta: {
				title: "Select Content",
				hideTopNav: true,
			},
		},
		// catch all - not found page
		{
			path: '*',
			name: 'Not Found',
			component: view404
		},
	]
})

const defaultTitle = 'Affinity'

router.beforeEach((to, from, next) => {
	document.title = to.meta.title ? to.meta.title : defaultTitle
	next()
})

export default router
